// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@awc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface OwnProps {
    extendedStyles?: CheckoutStepperStyles;
    currentStep?: "payment" | "confirmation";
}

type Props = OwnProps;

export interface CheckoutStepperStyles {
    step?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    operator?: TypographyPresentationProps;
}

export const checkoutStepperStyles: CheckoutStepperStyles = {};

const CheckoutStepper: FC<Props> = ({ currentStep, extendedStyles }) => {
    const styles = mergeWithCss(checkoutStepperStyles, extendedStyles);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.step} className={currentStep === "payment" ? "current-step" : ""}>
                {translate("Payment")}
            </Typography>
            <Typography {...styles.operator}>&gt;</Typography>
            <Typography {...styles.step} className={currentStep === "confirmation" ? "current-step" : ""}>
                {translate("Confirmation")}
            </Typography>
        </StyledWrapper>
    );
};

export default CheckoutStepper;
